import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

const Wrapper = styled.div`
  position: relative;

  ul {
    padding: 8px 16px;
    overflow-x: auto;
    list-style-type: none;
    white-space: nowrap;
    -webkit-overflow-scrolling: touch;
  }
`
const FadeRight = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  width: 28px;
  pointer-events: none;
  background: linear-gradient(
    to left,
    ${(props) => props.backgroundColor} 30%,
    rgba(255, 255, 255, 0) 100%
  );
`

const FadeLeft = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  width: 16px;
  pointer-events: none;
  background: linear-gradient(
    to right,
    ${(props) => props.backgroundColor} 30%,
    rgba(255, 255, 255, 0) 100%
  );
`

export default class SideScroll extends React.PureComponent {
  constructor(props) {
    super(props)
    this.setULRef = (element) => {
      this.ulRef = element
    }
  }

  componentDidUpdate() {
    if (this.ulRef) {
      this.ulRef.scrollLeft = 0
    }
  }

  render() {
    const { children, backgroundColor = '#ffffff' } = this.props

    return (
      <Wrapper ref={this.setULRef} data-cy="quickass">
        {children}
        <FadeRight backgroundColor={backgroundColor} />
        <FadeLeft backgroundColor={backgroundColor} />
      </Wrapper>
    )
  }
}

SideScroll.propTypes = {
  children: PropTypes.node.isRequired,
  backgroundColor: PropTypes.string,
}
